import { AutorizedRole, SupportedLanguageSchema } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

const CreateMagicLinkSchema = z
  .object({
    email: z.email().trim().toLowerCase().nullable(),
    userId: z.number().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    organizationName: z.string().nullable(),
    language: SupportedLanguageSchema,
  })
  .refine(
    (data) => {
      // Either userId or email must be present
      return data.userId || (data.email && data.email.trim().length > 0);
    },
    {
      message: 'Either userId or email must be provided',
      path: ['email', 'userId'],
    },
  );

/**
 * Can be used to create a magic link for an existing user or a new user
 * - If userId is provided, email is not required
 * - If userId is not provided, email is required
 */
export class CreateMagicLinkDto extends createZodDto(CreateMagicLinkSchema) {}

const CreateEditSimpleUserSchema = z
  .object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.email().trim().toLowerCase().nullable(),
    comment: z.string().nullable(),
    externalUserId: z.string().nullable(),
    role: z.enum(AutorizedRole),
    folderIds: z.array(z.number().int().positive()).optional().nullable(),
    tagIds: z.array(z.number().int().positive()).optional().nullable(),
    // Only applied on creation (see UsersService.createSimpleUser) — ignored
    // on update, editing a user's medical visit types goes through
    // SetUserMedicalVisitTypesDto instead.
    medicalVisitTypeIds: z
      .array(z.number().int().positive())
      .optional()
      .nullable(),
  })
  .refine(
    (data) => {
      // If role is not NONE, email must not be null or empty
      if (data.role !== AutorizedRole.NONE) {
        return data.email !== null && data.email.trim().length > 0;
      }
      // No requirement on email if role is NONE
      return true;
    },
    {
      message: 'Email is required for this role',
      path: ['email'],
    },
  );

export class CreateUpdateSimpleUserDto extends createZodDto(
  CreateEditSimpleUserSchema,
) {}

const UpdateCurrentUserSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  externalUserId: z.string().nullable(),
  shouldReceiveEmailPreference: z.boolean(),
});

const updateCurrentUserPasswordSchema = z.object({
  /*Account can have no password if only using SSO, so previous password is optional in that case*/
  oldPassword: z.string().trim().min(1).optional(),
  newPassword: z.string().min(12),
});

export class UpdateCurrentUserPasswordDto extends createZodDto(
  updateCurrentUserPasswordSchema,
) {}

//for personal user settings
export class UpdateCurrentUserDto extends createZodDto(
  UpdateCurrentUserSchema,
) {}

const UpdateLanguageSchema = z.object({
  language: z.string(),
});

export class UpdateLanguageDto extends createZodDto(UpdateLanguageSchema) {}

const InviteUserGroupSchema = z.object({
  userIds: z.array(z.number().int().positive()),
});

export class InviteUserGroupDto extends createZodDto(InviteUserGroupSchema) {}

const DeactivateUserGroupSchema = z.object({
  userIds: z.array(z.number().int().positive()),
});

export class DeactivateUserGroupDto extends createZodDto(
  DeactivateUserGroupSchema,
) {}
